type GeneticCodeId =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 33;

type GeneticCode = {
  id: GeneticCodeId;
  name: string;
  codonTable: Record<string, string>;
};

const BASES = ["T", "C", "A", "G"];

const CODONS: string[] = [];
for (const b1 of BASES) {
  for (const b2 of BASES) {
    for (const b3 of BASES) {
      CODONS.push(b1 + b2 + b3);
    }
  }
}

function buildCodonTable(aminoAcids: string): Record<string, string> {
  const table: Record<string, string> = {};
  for (let i = 0; i < 64; i++) {
    table[CODONS[i]] = aminoAcids[i];
  }
  return table;
}

const CODE_DATA: { id: GeneticCodeId; name: string; aminoAcids: string }[] = [
  {
    id: 1,
    name: "Standard",
    aminoAcids:
      "FFLLSSSSYY**CC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 2,
    name: "Vertebrate Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWLLLLPPPPHHQQRRRRIIMMTTTTNNKKSS**VVVVAAAADDEEGGGG",
  },
  {
    id: 3,
    name: "Yeast Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWTTTTPPPPHHQQRRRRIIMMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 4,
    name: "Mold, Protozoan, and Coelenterate Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 5,
    name: "Invertebrate Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWLLLLPPPPHHQQRRRRIIMMTTTTNNKKSSSSVVVVAAAADDEEGGGG",
  },
  {
    id: 6,
    name: "Ciliate, Dasycladacean, and Hexamita Nuclear",
    aminoAcids:
      "FFLLSSSSYYQQCC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 9,
    name: "Echinoderm and Flatworm Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWLLLLPPPPHHQQRRRRIIIMTTTTNNNKSSSSVVVVAAAADDEEGGGG",
  },
  {
    id: 10,
    name: "Euplotid Nuclear",
    aminoAcids:
      "FFLLSSSSYY**CCCWLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 11,
    name: "Bacterial, Archaeal, and Plant Plastid",
    aminoAcids:
      "FFLLSSSSYY**CC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 12,
    name: "Alternative Yeast Nuclear",
    aminoAcids:
      "FFLLSSSSYY**CC*WLLLSPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 13,
    name: "Ascidian Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWLLLLPPPPHHQQRRRRIIMMTTTTNNKKSSGGVVVVAAAADDEEGGGG",
  },
  {
    id: 14,
    name: "Alternative Flatworm Mitochondrial",
    aminoAcids:
      "FFLLSSSSYYY*CCWWLLLLPPPPHHQQRRRRIIIMTTTTNNNKSSSSVVVVAAAADDEEGGGG",
  },
  {
    id: 15,
    name: "Blepharisma Nuclear",
    aminoAcids:
      "FFLLSSSSYY*QCC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 16,
    name: "Chlorophycean Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY*LCC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 21,
    name: "Trematode Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWLLLLPPPPHHQQRRRRIIMMTTTTNNNKSSSSVVVVAAAADDEEGGGG",
  },
  {
    id: 22,
    name: "Scenedesmus obliquus Mitochondrial",
    aminoAcids:
      "FFLLSS*SYY*LCC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 23,
    name: "Thraustochytrium Mitochondrial",
    aminoAcids:
      "FF*LSSSSYY**CC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 24,
    name: "Rhabdopleuridae Mitochondrial",
    aminoAcids:
      "FFLLSSSSYY**CCWWLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSSKVVVVAAAADDEEGGGG",
  },
  {
    id: 25,
    name: "Candidate Division SR1 and Gracilibacteria",
    aminoAcids:
      "FFLLSSSSYY**CCGWLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 26,
    name: "Pachysolen tannophilus Nuclear",
    aminoAcids:
      "FFLLSSSSYY**CC*WLLLAPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 27,
    name: "Karyorelict Nuclear",
    aminoAcids:
      "FFLLSSSSYYQQCC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 28,
    name: "Condylostoma Nuclear",
    aminoAcids:
      "FFLLSSSSYYQQCCWWLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 29,
    name: "Mesodinium Nuclear",
    aminoAcids:
      "FFLLSSSSYYYYCC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 30,
    name: "Peritrich Nuclear",
    aminoAcids:
      "FFLLSSSSYYEECC*WLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 31,
    name: "Blastocrithidia Nuclear",
    aminoAcids:
      "FFLLSSSSYYEECCWWLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSRRVVVVAAAADDEEGGGG",
  },
  {
    id: 33,
    name: "Cephalodiscidae Mitochondrial",
    aminoAcids:
      "FFLLSSSSYYY*CCWWLLLLPPPPHHQQRRRRIIIMTTTTNNKKSSSKVVVVAAAADDEEGGGG",
  },
];

const GENETIC_CODES: Map<GeneticCodeId, GeneticCode> = new Map(
  CODE_DATA.map(({ id, name, aminoAcids }) => [
    id,
    { id, name, codonTable: buildCodonTable(aminoAcids) },
  ]),
);

const GENETIC_CODE_OPTIONS: { id: GeneticCodeId; name: string }[] =
  CODE_DATA.map(({ id, name }) => ({ id, name }));

const standardCode = GENETIC_CODES.get(1);

if (!standardCode) {
  throw new Error("Standard genetic code (1) is missing");
}

const STANDARD_CODON_TABLE = standardCode.codonTable;

function getCodonTable(id: GeneticCodeId): Record<string, string> {
  const code = GENETIC_CODES.get(id);

  if (!code) {
    throw new Error(`Genetic code ${id} is missing`);
  }

  return code.codonTable;
}

export {
  GENETIC_CODE_OPTIONS,
  GENETIC_CODES,
  type GeneticCode,
  type GeneticCodeId,
  getCodonTable,
  STANDARD_CODON_TABLE,
};
